"use client";

import dynamic from "next/dynamic";

import Container from "@/components/atom/Container";
import Crumbs from "@/components/atom/Crumbs";
import Footer from "@/components/atom/Footer";
import Loading from "@/components/atom/Loading";
import { getProduct } from "@/functions/databaseData";
import { useEffect, useMemo, useState } from "react";
import useHeader from "@/functions/useHeader";
import CardSeceleton from "@/components/seceleton/Card";
import uniqBy from "lodash/uniqBy";

const ProductList = dynamic(
  () =>
    import("@/components/atom/ProductList").then((module) => module.default),
  {
    ssr: false
  }
);

export default function Products() {
  const { session, status } = useHeader();
  const [datas, setDatas] = useState({ old: [], hits: [] });
  const [numPage, setNumPage] = useState(1);
  const [disableNextPage, setDisableNextPage] = useState(false);
  const [loading, setLoading] = useState({
    getAllHits: false,
    getAllOld: false
  });

  useEffect(() => {
    if (status == "loading") return;
    if (session?.user?.token) runWithAuth();
    else run();
  }, [session?.user?.token, status]);

  const run = async () => {
    try {
      let isDataHits = await getAllHits(false);
      // getAllOld(false, isDataHits ?? []);
    } catch (error) {
      console.log(error.message);
    }
  };

  const runWithAuth = async () => {
    try {
      let isDataHits = await getAllHits();
      // getAllOld(true, isDataHits ?? []);
    } catch (error) {
      console.log(error.message);
    }
  };

  async function getAllHits(auth = true, page = 1) {
    if (page <= 1) setLoading((old) => ({ ...old, getAllHits: true }));
    try {
      let payload = {
        page,
        hits: true,
        token: session?.user?.token,
        methodNextFetch: {
          cache: "no-store"
        }
      };

      if (!auth) delete payload.token;

      let datasProductHits = await getProduct(payload);

      datasProductHits =
        !datasProductHits || datasProductHits?.length <= 0 ? [] : datasProductHits;

      // disable next page jika data terakhir page kosong
      if (page > 1 && datasProductHits?.length <= 0) setDisableNextPage(true);

      console.log(datasProductHits?.length);

      if (datasProductHits?.length <= 0) return [];

      const isDataHits =
        datasProductHits?.filter((item) => item?.stock > 0) ?? [];

      setDatas((val) => ({
        ...val,
        hits:
          val?.hits?.length > 0
            ? uniqBy([...val?.hits, ...isDataHits], "_id")
            : isDataHits
      }));

      return datas?.hits?.length > 0 ? datas?.hits : isDataHits;
    } catch (error) {
      console.log("get all hits product: ", error.message);
    } finally {
      setLoading((old) => ({ ...old, getAllHits: false }));
    }
  }

  async function nextPage(num) {
    setLoading((old) => ({ ...old, nextPage: true }));
    try {
      console.log(session?.user?.token?.length > 0, num);

      await getAllHits(session?.user?.token?.length > 0, num);
      setNumPage(num);
    } catch (error) {
      console.log(`error next page : ${error?.message}`);
    } finally {
      setLoading((old) => ({ ...old, nextPage: false }));
    }
  }

  const isDatas = useMemo(() => {
    let arr = [];

    arr = datas?.hits?.length > 0 ? datas?.hits : [];
    // arr = datas?.old?.length > 0 ? [...arr, ...datas?.old] : arr;

    return arr;
  }, [
    // datas?.old?.length,
    datas?.hits?.length,
    loading?.getAllHits,
    loading?.getAllOld
  ]);

  if (status == "loading") {
    return <Loading />;
  }

  return (
    <div className="flex flex-col justify-between gap-6 mt-32">
      <div className="z-10">
        <div>
          <Container showMQ={false}>
            <div className="container-mini w-full">
              <Crumbs />
              {loading?.getAllHits || loading?.getAllOld ? (
                <div className={"grid-product-list pb-10 w-full"}>
                  {Array.from(Array(4).keys()).map((item) => (
                    <CardSeceleton key={item} />
                  ))}
                </div>
              ) : (
                <ProductList
                  datas={isDatas ?? []}
                  withoutPageSize
                  handleNextPage={{
                    show: !disableNextPage,
                    num: numPage,
                    loading: loading?.nextPage || loading.getAllOld,
                    disabled:
                      loading?.nextPage || disableNextPage || loading.getAllOld,
                    nextPage
                  }}
                />
              )}
            </div>
          </Container>
          <Footer />
        </div>
      </div>
    </div>
  );
}
